const PRINTFUL_ROUTE_PREFIX = "/dropshipping/printful";
const PRINTFUL_PAGES = Object.freeze([
  "DropshippingPlatforms", "DropshippingPlatformDetails", "DropshippingPrintfulConnect",
  "DropshippingSuppliers", "DropshippingSupplierProducts", "DropshippingAllProducts",
  "DropshippingProductDetails", "DropshippingImportedProducts", "DropshippingOrders",
  "DropshippingApiErrors", "DropshippingAdmin",
]);
module.exports = { PRINTFUL_ROUTE_PREFIX, PRINTFUL_PAGES };
